import { useEffect } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { useRateFieldName } from "../../../../hooks/useRateFieldName";

import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const useScheduleWindowValidation = (): void => {
  const { control, trigger } = useFormContext<StepTicketsFormData>();

  const startDateField = useRateFieldName("salesStartDate");
  const endDateField = useRateFieldName("salesEndDate");
  const startAfterRateField = useRateFieldName("salesStartAfterRateId");

  const startDate = useWatch({ control, name: startDateField });
  const endDate = useWatch({ control, name: endDateField });
  const startAfterRateId = useWatch({ control, name: startAfterRateField });

  useEffect(() => {
    const filledFields = [
      startDate ? startDateField : null,
      endDate ? endDateField : null,
      startAfterRateId ? startAfterRateField : null,
    ].filter((field): field is typeof startDateField => field !== null);

    if (filledFields.length === 0) {
      return;
    }
    void trigger(filledFields);
  }, [startDate, endDate, startAfterRateId, trigger, startDateField, endDateField, startAfterRateField]);
};
